<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showNewSancion"
    size="lg"
    scrollable
    no-close-on-backdrop
    title="Detalle de Sanción"
    @hidden="resetModal"
  >
    <b-row>
      <b-col md="1"
        ><span
          style="background: #dedede;
    padding: 3px;
    border-radius: 4px; font-size:11px"
          >{{ dataPartido.id_campeonato }}</span
        ></b-col
      >
      <b-col
        md="5"
        style="background: #dedede;
    padding: 3px;
    border-radius: 4px; font-size:11px"
        >Etapa {{ dataPartido.etapa }} - fecha #
        {{ dataPartido.num_fecha }} jugado el {{ dataPartido.fecha_aux }}</b-col
      >

      <b-col md="6" style="text-align:right"
        ><span
          style="background: #dedede;
    padding: 3px;
    border-radius: 4px;font-size:11px"
          >{{ dataPartido.local }} vs {{ dataPartido.visita }}</span
        ></b-col
      >
    </b-row>
    <b-row>
      <b-col md="5">
        <b-row>
          <b-col style="text-align:center" md="12">
            <img class="mt-1" width="50%" :src="dataSancion.foto_jug" alt="" />
          </b-col>
          <b-col md="12">
            <v-select
              placeholder="C.I / Pasaporte"
              :clearable="false"
              class="mb-1 mt-1"
              v-model="dataSancion.ci_pasaporte"
              :options="listPlayers"
              @search="searchPlayer"
              @input="changePlayer"
              :disabled="especialUnico ? false : true"
            />
          </b-col>
          <b-col md="12" style="margin-top:5px">
            <div class="form-label-group">
              <b-form-input
                id="floating-nombres"
                placeholder="Ingrese Nombres"
                size="sm"
                :formatter="formatter"
                :disabled="true"
                :value="dataSancion.nombres"
              />
              <label for="floating-nombres">Nombres</label>
            </div>
          </b-col>
          <b-col md="12" style="margin-top:5px">
            <div class="form-label-group">
              <b-form-input
                id="floating-apellidos"
                placeholder="Ingrese Apellidos"
                :formatter="formatter"
                size="sm"
                :disabled="true"
                :value="dataSancion.apellidos"
              />
              <label for="floating-apellidos">Apellidos</label>
            </div>
          </b-col>
          <b-col md="12" style="margin-top:5px">
            <div class="form-label-group">
              <b-form-input
                id="floating-club"
                placeholder="Ingrese Club"
                :formatter="formatter"
                :disabled="true"
                size="sm"
                :value="dataSancion.equipo"
              />
              <label for="floating-club">Club</label>
            </div>
          </b-col>
          <b-col md="12" style="margin-top:5px">
            <div class="form-label-group">
              <b-form-input
                id="floating-camiseta"
                placeholder="Ingrese # Camiseta"
                :formatter="formatter"
                :disabled="true"
                size="sm"
                :value="dataSancion.num_camiseta"
              />
              <label for="floating-club"># Camiseta</label>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="7">
        <span v-show="false">{{ setearComputed }}</span>
        <b-tabs>
          <b-tab
            v-if="
              dataSancion.tipo == 'n' ||
                dataSancion.tipo == '' ||
                dataSancion.tipo == undefined
            "
            :active="dataSancion.tipo == 'n' ? true : false"
            title="Normal"
            @click="defineTipoSancion('n')"
          >
            <b-row>
              <b-col md="12">
                <img
                  v-if="dataSancion.t_r == '1'"
                  :src="require('@/assets/images/recursos/roja.png')"
                  alt=""
                  width="20"
                  class="mr-1"
                />
                <img
                  v-else-if="dataSancion.doble_a == '1'"
                  :src="require('@/assets/images/recursos/dosamar.png')"
                  alt=""
                  width="20"
                  class="mr-1"
                />
                <img
                  v-else-if="dataSancion.acumulacion == 1"
                  :src="require('@/assets/images/recursos/amarilla.png')"
                  alt=""
                  width="20"
                  class="mr-1"
                />
                <small class="mr-1" v-if="dataSancion.t_r == '1'"
                  >ROJA DIRECTA
                </small>
                <small class="mr-1" v-else-if="dataSancion.doble_a == '1'"
                  >ROJA POR DOBLE AMARILLA
                </small>
                <small class="mr-1" v-else-if="dataSancion.acumulacion == 1"
                  >ACUMULACION DE AMARILLAS
                </small>
              </b-col>
              <b-col md="9">
                <v-select
                  placeholder="Seleccionar Artículo"
                  :clearable="false"
                  :options="listMotivos"
                  taggable
                  v-model="dataSancion.motivo"
                  @input="changeMotivo"
                  class="mb-1 mt-1 select-size-sm"
                />
              </b-col>
              <b-col md="3" class="mb-1 mt-1">
                <b-button
                  v-if="
                    USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.SANCIONES
                  "
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="warning"
                  size="sm"
                  @click="showNewMotivoOnly"
                >
                  <span>Nuevo</span>
                </b-button>
              </b-col>
              <b-col md="12">
                <b-form-textarea
                  id="textarea-auto-height"
                  placeholder="Detalle del articulo"
                  rows="2"
                  size="sm"
                  max-rows="3"
                  disabled
                  v-model="dataSancion.detalle"
                />
              </b-col>
              <b-col md="12" style="margin-top:5px">
                <b-badge
                  v-if="
                    dataSancion.duracion != null && dataSancion.duracion != 0
                  "
                  variant="warning"
                >
                  Se suguiere una suspensión de
                  {{ dataSancion.duracion_recomendada }} partidos según el
                  reglamento
                </b-badge>
              </b-col>
              <b-col md="12" style="text-align:right">
                <span
                  :id="`pop_info_importante`"
                  style="text-decoration:underline;color:red;cursor:pointer;font-size:10px"
                  >IMPORTANTE</span
                >
                <b-popover
                  ref="popover"
                  :target="`pop_info_importante`"
                  triggers="hover"
                  :show.sync="popoverShowIA"
                  placement="auto"
                  style="background:red !important"
                >
                  <div style="background:red;color:white; text-align:center">
                    <span>RECUERDA</span>
                  </div>
                  <div
                    style="max-height: 350px; overflow-y: auto; background:yellow;padding:5px"
                  >
                    El sistema buscará todos los partidos que esten pendientes
                    de jugarse, es decir mostrará fechas menores o mayores a
                    donde se obtuvo la tarjeta, te brindamos las herramientas
                    necesarias para no cometer errores, Asegúrate de validar la
                    información o corrígela de ser el caso
                  </div>
                </b-popover>
              </b-col>
              <b-col md="5" style="margin-top:10px">
                <div v-if="!isManual" class="form-label-group">
                  <b-form-input
                    v-if="dataSancion.aprobado == 'n'"
                    id="floating-duracion"
                    placeholder="Duración"
                    :formatter="formatter"
                    type="number"
                    size="sm"
                    value="3"
                    v-model="dataSancion.duracion"
                    @input="getPartidosAutomatico(dataSancion.duracion)"
                    :disabled="isManual"
                  />
                  <label for="floating-duracion">Duración</label>
                </div>
              </b-col>
              <b-col
                md="7"
                style="margin-top:20px; display:flex; text-align-items:center; justify-content:end"
              >
                <b-form-checkbox
                  v-model="isManual"
                  switch
                  @change="changeManual"
                  :disabled="dataSancion.aprobado == 's' ? true : false"
                >
                  <small>Manual</small>
                </b-form-checkbox>
              </b-col>

              <b-col md="1">
                <div style="width:13px;height:13px; background:#f3f39d"></div>
              </b-col>
              <b-col md="11" style="padding:0">
                <div style="font-size:10px;color:gray">
                  partidos menores a la fecha# {{ dataPartido.num_fecha }} donde
                  obtuvo la tarjeta
                </div>
              </b-col>
              <b-col md="1">
                <div style="width:13px;height:13px; background:#f8c867"></div>
              </b-col>
              <b-col md="11" style="padding:0">
                <div style="font-size:10px;color:gray">
                  partidos mayores a la fecha# {{ dataPartido.num_fecha }} donde
                  obtuvo la tarjeta
                </div>
              </b-col>

              <b-col md="12">
                <b-row
                  class="mt-1"
                  style="background-color:#e3e0e0; color:white; padding-top:5px; padding-bottom:5px"
                >
                  <b-col
                    md="12"
                    class="border-right d-flex justify-content-center align-items-center"
                    ><small
                      style="font-size:12px; font-weight:bold;color:#b93333"
                      >Detalle de partidos suspendidos
                    </small>
                  </b-col>
                </b-row>
                <b-row
                  class="mt-0 p-0 border"
                  style="background-color:#f1efef; color:white"
                >
                  <b-col
                    md="1"
                    class=" d-flex justify-content-center align-items-center"
                    style="padding:5px; "
                    ><small
                      style="font-size:10px; font-weight:bold;color:#b93333"
                      >Etapa</small
                    >
                  </b-col>
                  <b-col
                    md="1"
                    class="border-right d-flex justify-content-center align-items-center"
                    style="padding:5px"
                    ><small
                      style="font-size:10px; font-weight:bold;color:#b93333"
                      >Fecha</small
                    >
                  </b-col>
                  <b-col
                    style="padding:5px"
                    md="8"
                    class="text-center border-right"
                    ><small
                      style="font-size:10px; font-weight:bold;color:#b93333"
                      >Partido</small
                    >
                  </b-col>
                  <b-col
                    md="1"
                    class="d-flex justify-content-center align-items-center"
                    style="margin-left:5px"
                  ></b-col>
                </b-row>
                <b-overlay
                  :show="loadingPartidos"
                  rounded="sm"
                  :class="loadingPartidos ? 'mt-2' : 'mt-0'"
                >
                  <b-row
                    v-for="item in listPartidos"
                    :key="item.id"
                    class="mt-0 p-0 border"
                  >
                    <b-col
                      md="1"
                      :class="
                        Number(item.etapa) <= Number(dataPartido.etapa) &&
                        Number(item.num_fecha) < Number(dataPartido.num_fecha)
                          ? 'etapa'
                          : 'etapa-mayor'
                      "
                      style="padding:5px"
                      ><small>{{ item.etapa }}</small>
                    </b-col>
                    <b-col
                      md="1"
                      style="padding:5px"
                      :class="
                        Number(item.etapa) <= Number(dataPartido.etapa) &&
                        Number(item.num_fecha) < Number(dataPartido.num_fecha)
                          ? 'etapa'
                          : 'etapa-mayor'
                      "
                      ><small>{{ item.num_fecha }}</small>
                    </b-col>
                    <b-col
                      md="8"
                      style="padding:5px"
                      class="text-center border-right"
                      ><span
                        style="color: #929292;font-size: 10px;border-radius: 4px;float: left;background: #dddddd;padding-left: 3px;padding-right: 3px"
                        >{{ item.id_campeonato }}</span
                      ><small>{{ item.local }} vs {{ item.visita }}</small>
                    </b-col>
                    <b-col
                      v-if="isManual && item.final == 'PJ'"
                      md="1"
                      class="d-flex justify-content-center align-items-center"
                      style="margin-left:10px"
                      ><b-form-checkbox v-model="item.elegido">
                      </b-form-checkbox
                    ></b-col>
                  </b-row>
                </b-overlay>
              </b-col>
            </b-row>
            <div
              style="color:white;margin-top:5px;font-size: 14px;padding: 5px; background-color:#f24320; border-radius:3px"
              v-if="restantes > 0"
              md="12"
            >
              La sanción sera marcada como "POR ACTUALIZAR", quedarán
              <b> {{ restantes }}</b>
              partidos pendientes para completar la sanción en la siguiente
              etapa
            </div>
            <div
              style="color:white;margin-top:5px;font-size: 14px;padding: 5px; background-color:#f24320; border-radius:3px"
              v-if="dataSancion.num_pendientes > 0"
              md="12"
            >
              SANCIÓN "POR ACTUALIZAR", quedan
              <b> {{ dataSancion.num_pendientes }}</b>
              partidos pendientes que deben ser sancionados en la nueva etapa
              <span @click="aumentar" class="btn-aumenta">incrementar +</span
              ><span
                @click="disminuir"
                style="margin-left:7px"
                class="btn-aumenta"
                >disminuir -</span
              >
            </div>
          </b-tab>
          <b-tab
            v-if="
              dataSancion.tipo == 'e' ||
                dataSancion.tipo == '' ||
                dataSancion.tipo == undefined
            "
            :active="dataSancion.tipo == 'e' ? true : false"
            title="Especial"
            @click="defineTipoSancion('e')"
          >
            <b-row>
              <b-col md="12">
                <img
                  v-if="dataSancion.t_r == '1'"
                  :src="require('@/assets/images/recursos/roja.png')"
                  alt=""
                  width="20"
                  class="mr-1"
                />
                <img
                  v-else-if="dataSancion.doble_a == '1'"
                  :src="require('@/assets/images/recursos/dosamar.png')"
                  alt=""
                  width="20"
                  class="mr-1"
                />
                <img
                  v-else-if="dataSancion.acumulacion == 1"
                  :src="require('@/assets/images/recursos/amarilla.png')"
                  alt=""
                  width="20"
                  class="mr-1"
                />
                <small class="mr-1" v-if="dataSancion.t_r == '1'"
                  >ROJA DIRECTA
                </small>
                <small class="mr-1" v-else-if="dataSancion.doble_a == '1'"
                  >ROJA POR DOBLE AMARILLA
                </small>
                <small class="mr-1" v-else-if="dataSancion.acumulacion == 1"
                  >ACUMULACION DE AMARILLAS
                </small>
              </b-col>
              <b-col md="12">
                <v-select
                  placeholder="Seleccionar Motivo Adicional"
                  :clearable="false"
                  :options="listMotivos"
                  v-model="dataSancion.motivo"
                  @input="changeMotivo"
                  class="mb-1 mt-1 select-size-sm"
                />
              </b-col>
              <b-col md="12" style="margin-top:5px">
                <flat-pickr
                  v-model="dataSancion.rangeSancion"
                  class="form-control"
                  :config="{
                    mode: 'range',
                  }"
                  placeholder="Rango de Sancion"
                  size="sm"
                  @on-change="calculaDuracion"
                  @on-close="cerroCalendario"
                />
              </b-col>
              <b-col md="12" style="margin-top:5px">
                <b-badge v-if="duracionEspecial != null" variant="warning">
                  Duración: {{ duracionEspecial }}
                </b-badge>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-col
        v-if="dataSancion.id_sancion !== undefined"
        md="12"
        style="margin-top:10px;font-size: 12px;padding: 3px; background-color:gold; border-radius:3px"
      >
        <span
          ><b
            >Aplicada: {{ dataSancion.inicio_auxiliar }} por
            {{ dataSancion.userAplica }}</b
          >
        </span>
      </b-col>
      <b-col
        v-if="
          dataSancion.id_auditoria !== undefined &&
            dataSancion.id_auditoria !== null
        "
        md="12"
        style="margin-top:5px;font-size: 12px;padding: 3px; background-color:#fff8a5; border-radius:3px"
      >
        <span
          ><b
            >Modificada: {{ dataSancion.fecha_mod }}, ver auditoria #
            {{ dataSancion.id_auditoria }}</b
          >
        </span>
      </b-col>
      <div class="w-100">
        <template v-if="!showLoading">
          <b-button
            v-if="
              USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.SANCIONES
            "
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="insertSancion"
          >
            <span v-if="dataSancion.aprobado == 's'">Actualizar</span>
            <span v-else>Guardar</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
        </div>
        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px; z-index:1000"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  BModal,
  BTabs,
  BTab,
  BFormCheckbox,
  BButton,
  BAlert,
  BSpinner,
  BBadge,
  BOverlay,
  BFormTextarea,
  BPopover,
  // BListGroup,
  // BListGroupItem,
  // cxxx
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { heightFade } from '@core/directives/animations'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, computed, watch } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  URL,
  MOTIVOS_PRINCIPALES_SANCION,
  USER,
  ROLES,
} from '../../utils/variables'

const moment = require('moment-timezone')

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BModal,
    vSelect,
    BTabs,
    BTab,
    BFormCheckbox,
    BButton,
    BAlert,
    BSpinner,
    flatPickr,
    BBadge,
    BOverlay,
    BFormTextarea,
    BPopover,

    // BListGroup,
    // BListGroupItem,
  },
  directives: {
    // 'b-tooltip': VBTooltip,
    Ripple,
    heightFade,
  },
  props: {
    dataSancion: Object,
    dataPartido: Object,
    arrayPartidos: Array,
    listMotivos: Array,
    setear: Boolean,
    especialUnico: Boolean,
    categoriaSeleccionada: Object,
    isManualProp: Boolean,
    isOpen: Boolean,
  },
  setup(props, { emit }) {
    // eslint-disable-next-line
    const isManual = computed({
      get: () => props.isManualProp,
      set: value => {
        // props.isManualProp = value
        emit('changeManual', value)
      },
    })
    const listPartidos = ref([])
    const listPlayers = ref([])
    const duracion = ref(null)
    // const rangeSancion = ref(null)
    const { getApi, postApi } = apiCall()
    const etapaInicia = ref(null)
    const fechaInicia = ref(null)
    const showLoading = ref(false)
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const messageError = ref('')
    const detalleReglamento = ref('')
    const variante = ref('danger')
    // const tipoSancion = ref('n')
    const loadingPartidos = ref(false)
    const boton = ref()
    const duracionEspecial = ref(null)
    const dataRangeSancion = ref(null)
    const restantes = ref(0)
    const arrayAuxiliarSuspendidos = computed(() => props.arrayPartidos)
    const popoverShowIA = ref(null)

    // let listPartidos = computed({
    //   get: () => props.dataSancion.listPartidos,
    //   set: value => {
    //     // props.dataSancion.listPartidos = value
    //   },
    // })

    // async function getDetalleSancion(idTarjeta, idEquipo) {
    //   console.log(props)
    //   const path = `ApiSanciones/getSancionIdTarjetaRel/${idTarjeta}/${idEquipo}`
    //   const data = await getApi(URL, path)
    //   // console.log(data.data)
    //   // item.duracion = data.data.duracion
    //   // item.motivo = data.data.motS
    //   // item.listPartidos = data.detalle
    //   // dataSancion.value = item
    //   props.dataSancion.value.listPartidos = data.detalle
    //   // partidosSuspendidos.value = data.detalle
    //   // const action = store.getters['someVariables/getSancion']
    // }
    function changeManual() {
      // emit('changeManual')
    }
    function aumentar() {
      props.dataSancion.num_pendientes += 1
    }
    function disminuir() {
      // console.log('disum')
      if (props.dataSancion.num_pendientes >= 0) {
        props.dataSancion.num_pendientes -= 1
      }
    }
    function separaFecha() {
      let auxiliar = null
      // console.log(props.dataSancion.rangeSancion)
      if (props.dataSancion.rangeSancion != null) {
        const arrayFechas = props.dataSancion.rangeSancion.split('to')
        if (arrayFechas.length >= 2) {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[1].trim(),
          }
        } else {
          auxiliar = {
            valido: false,
            inicio: null,
            fin: null,
          }
        }
      }
      return auxiliar
    }
    function calculaDuracion() {
      const dataFecha = separaFecha()
      // let dura = ''
      // console.log(dataFecha)
      if (dataFecha != null) {
        if (dataFecha.valido) {
          dataRangeSancion.value = dataFecha
          const { inicio, fin } = dataFecha
          const finaliza = moment(fin)
          const inicia = moment(inicio)
          // console.log(fin)
          const diffDuration = moment.duration(
            // eslint-disable-next-line
            finaliza.diff(inicia)
          )
          // console.log(diffDuration)
          duracionEspecial.value = `${diffDuration.years()} años ${diffDuration.months()} meses ${diffDuration.days()} días`
          // console.log(duracionEspecial.value)
          emit('changeRange', duracionEspecial.value)
          // dura = `${diffDuration.years()} años ${diffDuration.months()} meses ${diffDuration.days()} días`
        }
      }
      // return dura
    }
    // const duracionEspecial = computed(() => calculaDuracion())
    // const duracionEspecial = computed({
    //   get: () => {
    //     // return store.getters['someVariables/getSancion']
    //     props.dataSancion.duracionEspecial
    //   },
    //   set: value => {
    //     props.dataSancion.duracionEspecial = value
    //   },
    // })
    function changeRange() {
      emit('changeRange', props.dataSancion.rangeSancion)
      // duracionEspecial.value = calculaDuracion()
    }

    const setearComputed = computed({
      get: () => {
        if (props.setear) {
          // console.log(props.dataSancion)
          duracionEspecial.value = props.dataSancion.duracionEspecial
          listPartidos.value = props.dataSancion.listPartidos
        }
        // return store.getters['someVariables/getSancion']
        return props.setear
      },
      set: value => {
        props.setear = value
      },
      // () => {
      // console.log('cambio data')
      // console.log(props.setear)
      // if (props.setear) {
      //   listPartidos.value = props.dataSancion.listPartidos
      // }
      // // return store.getters['someVariables/getSancion']
      // return props.setear
    })

    // const rangeSancion = ref(
    //   computed(
    //     // eslint-disable-next-line
    //     () =>
    //     // eslint-disable-next-line
    //       `${props.dataSancion.fecha_incio_sancion} to ${props.dataSancion.fecha_fin_especial}`
    //     // eslint-disable-next-line
    //   )
    // )
    function cerroCalendario() {
      // console.log(rangeSancion.value)
      if (props.dataSancion.rangeSancion === '') {
        duracionEspecial.value = null
      }
    }

    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      // hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function formatter(value) {
      return value.toUpperCase()
    }
    function defineTipoSancion(tipo) {
      // console.log(tipo)
      // tipoSancion.value = tipo
      emit('changeTipoSancion', tipo)
    }
    // function definirEtapaFechaInicioSancion() {
    //   etapaInicia.value = listPartidos.value[0].etapa
    //   fechaInicia.value = listPartidos.value[0].num_fecha
    //   // etapaInicia.value = props.dataSancion.listPartidos[0].etapa
    //   // fechaInicia.value = props.dataSancion.listPartidos[0].num_fecha
    // }
    function calcularRestantes() {
      return props.dataSancion.duracion - listPartidos.value.length
    }
    async function getPartidosAutomatico(value) {
      // console.log(value)
      // props.dataSancion.listPartidos = []
      listPartidos.value = []
      if (value != null) {
        if (value.length >= 1) {
          loadingPartidos.value = true
          const path = `ApiSanciones/getPartidosASuspender/${props.dataSancion.id_equipo}/${value}/${props.dataPartido.num_fecha}/${props.dataPartido.id_campeonato}`
          const data = await getApi(URL, path)
          listPartidos.value = data.data
          restantes.value = calcularRestantes()
          // dataSancionAuxiliar.value.listPartidos = data.porSuspender
          // store.commit(
          //   'someVariables/UPDATE_SANCION',
          //   // eslint-disable-next-line
          //   props.dataSancion
          // )
          loadingPartidos.value = false
          // definirEtapaFechaInicioSancion()
        } else {
          // console.log('dos')
          // props.dataSancion.listPartidos = []
          listPartidos.value = []
          etapaInicia.value = null
          fechaInicia.value = null
          restantes.value = 0
        }
      }
    }
    async function getPartidosManual(value) {
      // console.log(props.dataPartido)
      // isManual.value = true
      // props.dataSancion.listPartidos = []

      // if(props.dataSancion.id_sancion!=null){
      //
      // }
      // console.log(props.dataSancion.motivo)
      listPartidos.value = []
      let data
      // console.log(isManual.value)
      if (isManual.value) {
        restantes.value = 0
        loadingPartidos.value = true
        const path = `ApiSanciones/partidosPendienteSancion/${props.dataSancion.id_equipo}/${value}/${props.dataPartido.id_campeonato}`
        data = await getApi(URL, path)
        // props.dataSancion.listPartidos = data.porSuspender
        let dataObtenida = []
        if (props.dataSancion.aprobado === 's') {
          emit('resetSetear')
          dataObtenida = data.suspendidos.concat(data.porSuspender)
        } else {
          dataObtenida = data.porSuspender
        }
        // console.log(dataObtenida)
        // dataObtenida.forEach(element => {
        //   element.elegido = false
        // })
        listPartidos.value = dataObtenida
        props.dataSancion.duracion = 0
        loadingPartidos.value = false
      } else {
        listPartidos.value = []
        // console.log(props.dataSancion.motivo)
        if (
          props.dataSancion.motivo !== undefined &&
          props.dataSancion.motivo != null
        ) {
          props.dataSancion.duracion =
            props.dataSancion.motivo.dataReglamento.total_partidos
        } else {
          props.dataSancion.duracion = undefined
        }

        getPartidosAutomatico(props.dataSancion.duracion)
        if (props.dataSancion.aprobado === 's') {
          emit('trueSetear')
        }
      }
      // dataSancionAuxiliar.value.listPartidos = data.porSuspender
      // store.commit(
      //   'someVariables/UPDATE_SANCION',
      //   // eslint-disable-next-line
      //   props.dataSancion
      // )
      // dataSancionAuxiliar.value.listPartidos = data.porSuspender
      // console.log(dataSancionAuxiliar.value)
      // definirEtapaFechaInicioSancion()
    }
    watch(isManual, () => {
      // if (data) {
      // console.log(store.getters['someVariables/getStateShowNewSancion'])
      const isOpen = store.getters['someVariables/getStateShowNewSancion']
      if (isOpen) {
        getPartidosManual(props.dataSancion.id_sancion)
      }
      // }
    })

    // watch(boton, valor => {
    //   console.log(valor)
    //   // if (valor) {
    //   //   manual('0')
    //   // } else {
    //   //   console.log('nada')
    //   // }
    // })

    function definirMotivoPrincipal() {
      let motivoPrincipal = null
      if (props.dataSancion.doble_a === '1') {
        motivoPrincipal = MOTIVOS_PRINCIPALES_SANCION.DOBLE_TA
        // console.log('doble')
      } else if (props.dataSancion.t_r === '1') {
        motivoPrincipal = MOTIVOS_PRINCIPALES_SANCION.ROJA
        // console.log('roja')
      } else if (
        props.dataSancion.t_a === '1' &&
        props.dataSancion.orden === props.dataSancion.totAmaParSusp
      ) {
        motivoPrincipal = MOTIVOS_PRINCIPALES_SANCION.ACUMULACION_AMARILLAS
        // console.log('acumu')
      }
      return motivoPrincipal
    }
    function showNewMotivoOnly() {
      emit('onlyMotivo')
    }
    function funcionalidadMotivo(item) {
      if (item.label !== null) {
        props.dataSancion.detalle = `${
          item.dataReglamento.detalle == null ? '' : item.dataReglamento.detalle
        } (valor ${item.dataReglamento.valor})`
        props.dataSancion.duracion = item.dataReglamento.total_partidos
        props.dataSancion.duracion_recomendada =
          item.dataReglamento.total_partidos
        getPartidosAutomatico(props.dataSancion.duracion_recomendada)
        // console.log(item.value)
        if (item.value === undefined) {
          item.value = null
        }
      }
    }
    function changeMotivo(item) {
      // console.log(item)
      if (!isManual.value) {
        funcionalidadMotivo(item)
      }
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', false)

      // emit('recargar', props.playerSelected.id_equipo)
      // hasError.value = false
      listPartidos.value = []
      // props.setear = false
      emit('resetSetear')
      emit('changeManual', false)

      props.dataSancion.motivo = null
      props.dataSancion.duracion = 0
      // isManual.value = false
      showLoading.value = false
      props.dataSancion.rangeSancion = null
      dataRangeSancion.value = null
      duracionEspecial.value = null
      props.dataSancion.detalle = null
      restantes.value = 0
      store.commit(
        'someVariables/UPDATE_ACTIVATE_SANCION_PENDIENTE',
        // eslint-disable-next-line
        false
      )
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', false)
      store.commit(
        'someVariables/UPDATE_ACTIVATE_SANCION_PENDIENTE',
        // eslint-disable-next-line
        false
      )
    }
    function hasError(listPartidosFiltrados) {
      let error = false
      // console.log(isManual.value, listPartidos.value)
      if (isManual.value) {
        // console.log(props.dataSancion.id_sancion)
        if (props.dataSancion.id_sancion === undefined) {
          if (listPartidosFiltrados.length === 0) {
            showMessageAlert('danger', 'Debe seleccionar almenos un partido')
            error = true
          }
        }
      } else if (!isManual.value) {
        // console.log(props.dataSancion.motivo)
        if (
          props.dataSancion.motivo !== null &&
          props.dataSancion.motivo !== undefined
        ) {
          if (
            props.dataSancion.motivo.value === undefined ||
            props.dataSancion.motivo.value === null
          ) {
            showMessageAlert('danger', 'El artículo seleccionado no es valido')
            error = true
          } else if (
            props.dataSancion.duracion === undefined ||
            props.dataSancion.duracion === '0' ||
            props.dataSancion.duracion === 0 ||
            props.dataSancion.duracion === null
          ) {
            showMessageAlert('danger', 'Duración debe ser diferente de cero')
            error = true
          }
        } else {
          showMessageAlert('danger', 'El artículo seleccionado no es valido')
          error = true
        }
      }

      return error
    }
    function hasErrorEspecial() {
      let error = false
      if (
        props.dataSancion.motivo === undefined ||
        props.dataSancion.motivo === null
      ) {
        showMessageAlert('danger', 'Seleccione o agregue el motivo')
        error = true
      } else if (
        props.dataSancion.rangeSancion === undefined ||
        props.dataSancion.rangeSancion === null
      ) {
        showMessageAlert('danger', 'Seleccione un rango de fechas a sancionar')
        error = true
      }
      return error
    }
    function filtrarPartidos(tipoManual, listPartidosIngreso) {
      let arraySalida = []
      if (tipoManual) {
        listPartidosIngreso.forEach(element => {
          if (element.elegido) {
            arraySalida.push(element)
          }
        })
      } else {
        arraySalida = listPartidosIngreso
      }
      return arraySalida
    }
    async function insertSancionNormal() {
      const partidosEnviar = filtrarPartidos(isManual.value, listPartidos.value)
      // console.log(partidosEnviar)
      const error = hasError(partidosEnviar)
      let duracionEviar = 0
      // console.log(props.dataSancion.duracion)
      if (!error) {
        let cambioMotivo = ''
        if (
          props.dataSancion.id_motivo_sancion_ant !==
          props.dataSancion.motivo.value
        ) {
          cambioMotivo += `; Artículo antiguo : ${props.dataSancion.motivo_ant} ; Artículo nuevo: ${props.dataSancion.motivo.label} `
        }
        if (isManual.value) {
          duracionEviar = partidosEnviar.length
        } else {
          duracionEviar = props.dataSancion.duracion
        }
        // console.log(duracionEviar)
        showLoading.value = true
        // console.log(props.dataSancion)
        const path = 'ApiSanciones/insertSancion'
        const data = {
          tipo_sancion: 'n',
          idCategoria: props.dataSancion.id_categoria,
          id_jugador: props.dataSancion.id_jugador,
          id_tarjeta_rel: props.dataSancion.id_tarjeta,
          id_motivo_sancion: props.dataSancion.motivo.value,
          motivo_nuevo: props.dataSancion.motivo.label,
          id_motivo_sancion_prin: definirMotivoPrincipal(),
          etapa_auxiliar: props.dataPartido.etapa,
          num_pendientes: props.dataSancion.num_pendientes,
          num_pendientes_inicial: props.dataSancion.num_pendientes_entrada,
          nueva_duracion:
            props.dataSancion.num_pendientes + partidosEnviar.length,
          // inicio_sancion: fechaInicia.value,
          duracion_sancion: duracionEviar,
          id_sancion: props.dataSancion.id_sancion,
          // id_sancion: null,
          id_sancion_pendiente: props.dataSancion.id_sancion_pendiente,
          estado_s: 'n',
          restantes: calcularRestantes(),
          detalleSan: partidosEnviar,
          idUsuario: USER().id_usuario,
          idTorneo:
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
          dataMovimiento: {
            partidos: arrayAuxiliarSuspendidos.value,
            newMotivo: cambioMotivo,
            antDuracion: `, cambia de: ${
              props.dataSancion.duracion_ant
            } a ${props.dataSancion.num_pendientes +
              partidosEnviar.length} partidos`,
            numCamiseta: props.dataSancion.num_camiseta,
            dataEquipo: `${props.dataSancion.equipo} ${props.dataPartido.categoria}`,
            dataPartido: `Aplicado en el partido del ${props.dataPartido.fecha} - ${props.dataPartido.local} vs ${props.dataPartido.visita}`,
          },
        }
        // console.log(data)
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', false)
          props.dataSancion.bloquear = 's'
          props.dataSancion.aprobado = 's'
          emit('recargaMotivos', data.id_tarjeta_rel)
        } else {
          // console.log('no')
          // errorInUpdateExtras(tipoCampo)
          showMessageAlert('danger', response.mensaje)
          // this.$ct(
          //   {
          //     component: ToastificationContent,
          //     props: {
          //       title: 'ERROR no se pudo actualizar',
          //       icon: 'AlertCircleIcon',
          //       variant: 'danger',
          //       solid: true,
          //     },
          //   },
          //   {
          //     position: 'bottom-center',
          //     // eslint-disable-next-line
          //   }
          // )
        }
        showLoading.value = false
      }

      //   cardItem.value.showLoading = false
    }
    async function insertSancionEspecial() {
      const error = hasErrorEspecial()
      if (!error) {
        showLoading.value = true
        // console.log(props.dataSancion)
        dataRangeSancion.value = separaFecha()
        // console.log(dataRangeSancion.value)
        const path = 'ApiSanciones/insertSancion'
        const data = {
          tipo_sancion: 'e',
          id_jugador: props.dataSancion.id_jugador,
          id_motivo_sancion: props.dataSancion.motivo.value,
          motivo_nuevo: props.dataSancion.motivo.label,
          fecha_inicio: dataRangeSancion.value.inicio,
          fecha_fin: dataRangeSancion.value.fin,
          id_tarjeta_rel: props.dataSancion.id_tarjeta,
          id_sancion: props.dataSancion.id_sancion,
          id_motivo_sancion_prin: definirMotivoPrincipal(),
          estado_s: 'n',
          idUsuario: USER().id_usuario,
          idTorneo:
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
          dataMovimiento: `Cambia sanción especial del jugador con C.I ${props.dataSancion.ci_pasaporte} info inicial:
           ${props.dataSancion.inicio_auxiliar} al ${props.dataSancion.fin_auxiliar} motivo: ${props.dataSancion.motivo_auxiliar} modificado  a ${dataRangeSancion.value.inicio} -
           ${dataRangeSancion.value.fin} motivo: ${props.dataSancion.motivo.label}`,
        }
        // console.log(data)
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', false)
          props.dataSancion.bloquear = 's'
          props.dataSancion.aprobado = 's'
          emit('recargaEspeciales')
        } else {
          // console.log('no')
        }
        showLoading.value = false
      }
    }
    function insertSancion() {
      // console.log(props.dataSancion)
      // console.log(props.dataSancion.tipo)
      if (
        props.dataSancion.tipo === 'n' ||
        props.dataSancion.tipo === undefined
      ) {
        insertSancionNormal()
      } else {
        insertSancionEspecial()
      }
    }
    async function searchPlayer(value) {
      listPlayers.value = []
      // console.log(value)
      // console.log(props.playerSelected)
      if (value.length) {
        const path = `ApiSanciones/getJugadoresEspecial/${value}`
        const data = await getApi(URL, path)
        // this.listPlayers.value = data.jugadores
        // if (data.flag === 'si') {
        // listPlayers.value = []
        data.data.forEach(element => {
          const obj = {
            label: `${element.ci_pasaporte}`,
            value: element.id_jugador,
            apellidos: element.apellidos,
            nombres: element.nombres,
            foto_jug: element.foto_jug,
            id_jugador: element.id_jugador || null,
          }
          listPlayers.value.push(obj)
        })
      } else {
        listPlayers.value = []
      }
    }
    function changePlayer(item) {
      // console.log(item)
      if (item !== null) {
        props.dataSancion.nombres = item.nombres
        props.dataSancion.apellidos = item.apellidos
        props.dataSancion.equipo = '-'
        props.dataSancion.num_camiseta = '-'
        props.dataSancion.foto_jug = item.foto_jug
        props.dataSancion.id_jugador = item.id_jugador
        props.dataSancion.id_tarjeta = null
      }
    }

    return {
      formatter,
      isManual,
      // listPartidos,
      getPartidosAutomatico,
      duracion,
      etapaInicia,
      fechaInicia,
      insertSancion,
      showLoading,
      messageError,
      variante,
      dismissSecs,
      countDownChanged,
      dismissCountDown,
      showMessageAlert,
      defineTipoSancion,
      // tipoSancion,
      changeMotivo,
      resetModal,
      onlyClose,
      // arrayAuxiliar,
      // dataSancionAuxiliar,
      getPartidosManual,
      boton,
      listPartidos,
      setearComputed,
      // rangeSancion,
      calculaDuracion,
      duracionEspecial,
      cerroCalendario,
      changeRange,
      searchPlayer,
      listPlayers,
      changePlayer,
      loadingPartidos,
      ROLES,
      USER,
      showNewMotivoOnly,
      detalleReglamento,
      changeManual,
      restantes,
      popoverShowIA,
      aumentar,
      disminuir,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.etapa {
  border-right: 1px solid #ebe9f1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(243, 243, 157);
}
.etapa-mayor {
  border-right: 1px solid #ebe9f1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(248, 200, 103);
}
.btn-aumenta {
  font-size: 11px;
  text-decoration: underline;
  color: #f7f7f7;
  text-transform: uppercase;
  background: steelblue;
  padding: 3px;
  border-radius: 3px;
  cursor: pointer;
}
</style>
